<div class="stepper-container">
  <div class="stepper-header">
    <div class="back-button-container">
      <app-back-arrow-button
        [label]="'TGA.BackToTGAInsights' | translate"
        [action]="navigateToTGAInsights"
      ></app-back-arrow-button>
    </div>
  </div>
  <div class="stepper-scroll-container">
    <app-stepper></app-stepper>
  </div>
</div>
<div class="questionnaire-container">
  <div class="buttons-container buttons-container--top">
    <button mat-button class="btn btn--secondary" (click)="navigateToCropFieldSelection()">
      {{ 'TGA.BackToCropFieldSelection' | translate }}
    </button>
    @if ((mode$ | async) === 'questionnaire' && (questionnaireType$ | async) === 'generic') {
      <app-crop-year-selector class="questionnaire-crop-year-selector" [readOnly]="true" />
    }
    @if ((mode$ | async) === 'questionnaire' && (questionnaireType$ | async) === 'specific') {
      <button mat-button class="btn btn--primary" (click)="navigateToAdvices()">
        {{ 'TGA.ToAdvices' | translate }}
      </button>
    } @else if ((mode$ | async) === 'advice') {
      <button mat-button class="btn btn--highlight" (click)="navigateToQuestionnaire()">
        {{ 'TGA.ToQuestionnaire' | translate }}
      </button>
    }
  </div>
  <div class="questionnaire-content-container">
    <ng-content>
      @if ((mode$ | async) === 'questionnaire') {
        @if (
          (activeStep$ | async)?.translationKey === 'General' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          @if ((questionnaireType$ | async) === 'generic') {
            <app-generic-general-questionnaire></app-generic-general-questionnaire>
          } @else if ((questionnaireType$ | async) === 'specific') {
            <app-specific-general-questionnaire></app-specific-general-questionnaire>
          } @else {
            <p>{{ 'TGA.NoQuestionsAvailable' | translate }}</p>
          }
        } @else if (
          (activeStep$ | async)?.translationKey === 'Soil' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          @if ((questionnaireType$ | async) === 'generic') {
            <app-generic-soil-questionnaire></app-generic-soil-questionnaire>
          } @else if ((questionnaireType$ | async) === 'specific') {
            <app-specific-soil-questionnaire></app-specific-soil-questionnaire>
          } @else {
            <p>{{ 'TGA.NoQuestionsAvailable' | translate }}</p>
          }
        } @else if (
          (activeStep$ | async)?.translationKey === 'Planting' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          @if ((questionnaireType$ | async) === 'specific') {
            <app-specific-planting-questionnaire></app-specific-planting-questionnaire>
          } @else if ((questionnaireType$ | async) === 'generic') {
            <app-generic-planting-questionnaire></app-generic-planting-questionnaire>
          } @else {
            <p>{{ 'TGA.NoQuestionsAvailable' | translate }}</p>
          }
        } @else if (
          (activeStep$ | async)?.translationKey === 'Growing' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          <app-no-questions
            [title]="'TGA.Advice.Cultivation.Title' | translate"
            [questionnaireType]="questionnaireType$ | async"
            [cropFieldId]="cropFieldId"
            [cropYear]="cropYear"
          ></app-no-questions>
        } @else if (
          (activeStep$ | async)?.translationKey === 'Evaluation' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          <app-no-questions
            [title]="'TGA.Advice.Evaluation.Title' | translate"
            [questionnaireType]="questionnaireType$ | async"
            [cropFieldId]="cropFieldId"
            [cropYear]="cropYear"
          ></app-no-questions>
        }
      } @else if ((mode$ | async) === 'advice') {
        @if (
          (activeStep$ | async)?.translationKey === 'General' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          <app-tga-general-advice></app-tga-general-advice>
        } @else if (
          (activeStep$ | async)?.translationKey === 'Soil' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          <app-tga-soil-advice></app-tga-soil-advice>
        } @else if (
          (activeStep$ | async)?.translationKey === 'Planting' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          <app-tga-planting-advice></app-tga-planting-advice>
        } @else if (
          (activeStep$ | async)?.translationKey === 'Growing' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          <app-tga-cultivation-advice></app-tga-cultivation-advice>
        } @else if (
          (activeStep$ | async)?.translationKey === 'Evaluation' && (activeStep$ | async)?.status === stepStatus.Active
        ) {
          <app-tga-evaluation-advice />
        }
      }
    </ng-content>
    @if ((mode$ | async) === 'questionnaire') {
      <div class="buttons-container buttons-container--bottom">
        @if (nextStepTranslationKey$ | async; as nextStep) {
          <button
            mat-button
            class="btn btn--highlight margin-top"
            (click)="onNextQuestionnaireClick()"
            [class.btn--disabled]="!(isNextStepEnabled$ | async)"
            [disabled]="!(isNextStepEnabled$ | async)"
          >
            {{ 'TGA.ToQuestionnaire' | translate }} {{ 'TGA.Steps.' + nextStep | translate | lowercase }}
          </button>
        }
        <button mat-button class="btn btn--secondary" (click)="navigateToCropFieldSelection()">
          {{ 'TGA.BackToCropFieldSelection' | translate }}
        </button>
      </div>
      <div class="mobile-bottom-nav">
        @if ((questionnaireType$ | async) === 'specific') {
          <button mat-button class="btn btn--primary width-100" (click)="navigateToAdvices()">
            {{ 'TGA.ToAdvices' | translate }}
          </button>
        }
      </div>
    }
  </div>
</div>
